// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_6afd6d7a","icon":"_a2a629a9","hasUnread":"_ab104071"};